<!-- Fenêtre de livraison location : mêmes deux colonnes et même feuille que la fenêtre F2 (delivery.component.scss), sans grille lignes × BL ni historique. -->
@if (order) {
<div class="dlg">

	<header class="mast">
		<div class="mast-facts">
			<div class="fact">
				<span class="lbl">Dossier</span>
				<span class="docref"><i>N°</i>{{ order.id }}@if (active?.id) { · BL {{ active!.id }} }@for (s of sales; track s.order.id) { @if (s.active?.id) { · BL {{ s.active!.id }} <i>vente</i> } }</span>
			</div>
			<!-- Même trame que l'en-tête du dossier : livraison en vert à gauche, facturation en jaune à droite quand le payeur n'est pas le bénéficiaire. -->
			<div class="fact party deliv">
				<span class="lbl">{{ isDistinctBeneficiary ? 'Bénéficiaire · livré' : 'Client · livré' }}</span>
				<span class="val strong"><button type="button" class="party-link" (click)="openParty(deliveryOwnerId)" [disabled]="!deliveryOwnerId" [matTooltip]="isDistinctBeneficiary ? 'Fiche du tiers bénéficiaire' : 'Fiche du tiers'">{{ deliveryName }}</button></span>
				<span class="val">{{ addressLabel }}</span>
			</div>
			@if (isDistinctBeneficiary) {
				<div class="fact party bill">
					<span class="lbl">Payeur · facturé</span>
					<span class="val strong"><button type="button" class="party-link" (click)="openParty(order.customer)" [disabled]="!order.customer" matTooltip="Fiche du tiers payeur">{{ customerLabel }}</button></span>
					<span class="val">{{ billAddressLabel }}</span>
				</div>
			}
			<!-- BL enregistré avec un jour de livraison : le lien « Voir au planning » de la snack bar reste à portée (nouvel onglet, fenêtre fermée). -->
			@if (savedPlanningLink; as link) {
				<div class="fact">
					<span class="lbl">Logistique</span>
					<span class="val"><button type="button" class="party-link" id="rentalplanninglink" (click)="link.run()" matTooltip="Tournées du jour de ce BL, BL encadré (nouvel onglet)">{{ link.label }}</button></span>
				</div>
			}
		</div>
		<span class="grow"></span>
		<div class="mast-acts">
			<button type="button" class="btn" id="rentalsignnowbutton" [disabled]="locked || isSaving || salesLoading || !blRows.length" (click)="onSignNow()"
				matTooltip="Matériel emporté ou rapporté au magasin : le client signe le BL tout de suite"><mat-icon>fact_check</mat-icon>Signer maintenant</button>
			<button type="button" class="btn blue" id="rentalprintbutton" [disabled]="isSaving || salesLoading || (!locked && !blRows.length)" (click)="onPrint()">
				<mat-icon>print</mat-icon>{{ locked ? 'Imprimer le BL signé' : 'Planifier + imprimer le BL' }}</button>
			<button type="button" class="btn green" id="rentalplanbutton" [disabled]="locked || isSaving || salesLoading || !blRows.length" (click)="onPlan()">
				<mat-icon>event_available</mat-icon>Planifier</button>
		</div>
		<button class="icon-btn danger" type="button" (click)="close()" matTooltip="Fermer" aria-label="Fermer"><mat-icon>close</mat-icon></button>
	</header>

	<div class="body">
		<section class="col-lines">

			<p class="help"><mat-icon>info</mat-icon><span>Un BL = une livraison à une date · « + Nouveau BL » pour une autre date · « Livré le… » pour valider la livraison faite</span></p>

			@if (locked) {
				<div class="locked">
					<mat-icon>lock</mat-icon>
					<span>BL {{ active!.id }} livré le <strong>{{ active!.realdatdel | tzdate: 'DD/MM/YYYY' }}</strong> à <strong>{{ active!.realdatdel | tzdate: 'HH:mm' }}</strong> — non modifiable</span>
				</div>
			}

			<!-- Chaque BL ouvert du dossier a son onglet, même seul, avec son jour et son créneau (JP 31/10) ; jamais l'historique des BL signés. -->
			<div class="blk livs">
				<div class="livtabs">
					@for (d of openBls; track d.id) {
						<button type="button" class="livtab" [class.active]="active?.id === d.id" (click)="selectBl(d)" [disabled]="isSaving">
							<span>BL {{ d.id }}</span><span class="when">{{ blWhen(d) }}</span>
						</button>
					}
					@if (locked) { <button type="button" class="livtab signed active"><mat-icon>lock</mat-icon><span>BL {{ active!.id }}</span><span class="when">livré {{ active!.realdatdel | tzdate: 'DD/MM' }}</span></button> }
					@if (!active) { <button type="button" class="livtab active"><span>Nouveau BL</span><span class="when">à planifier</span></button> }
					<span class="grow"></span>
					@if (active?.id && !locked) {
						<button mat-stroked-button class="liv-btn" type="button" id="rentaldeliveredbutton" (click)="onDelivered()" [disabled]="isSaving || salesLoading"
							matTooltip="La livraison de ce BL a eu lieu : la déclarer faite, au jour choisi (le BL ne se modifie plus)"><mat-icon>task_alt</mat-icon>Livré le…</button>
					}
					<button mat-stroked-button color="primary" class="liv-btn" type="button" id="rentalnewblbutton" (click)="newBl()" [disabled]="!active || isSaving || salesLoading"
						[matTooltip]="active ? 'Une autre livraison pour ce client, à une autre date : seuls les matériels qui ne sont sur aucun BL ouvert y vont' : 'Ce nouveau BL est affiché : planifiez-le d\'abord'"><mat-icon>add</mat-icon>Nouveau BL (autre date)</button>
				</div>
			</div>

			<div class="scroll-y grow">
				<div class="grid lines-grid">
					<div class="row head">
						<div class="c c-check">
							@if (!locked) {
								<input type="checkbox" [checked]="allChosen" [indeterminate]="someChosen && !allChosen" [disabled]="isSaving" (change)="toggleAll($any($event.target))"
									[attr.aria-label]="allChosen ? 'Tout retirer du BL' : 'Tout mettre sur le BL'" [matTooltip]="allChosen ? 'Tout décocher' : 'Tout cocher'">
							}
						</div>
						<div class="c c-dir"></div>
						<div class="c c-seq">#</div>
						<div class="c">Patient</div>
						<div class="c">Matériel ou article — Unité de vente</div>
						<div class="c c-num">Qté</div>
					</div>

					<div class="row group"><div class="c">{{ locked ? 'Sur ce BL' : active?.id ? 'Sur ce BL' : 'Sur le BL à créer' }} ({{ blRows.length }})</div></div>
					@for (r of blRows; track r.id) {
						<ng-container *ngTemplateOutlet="row; context: { $implicit: r }"></ng-container>
					}
					@if (!blRows.length) { <div class="row empty"><div class="c">Aucun matériel sur ce BL : cochez ci-dessous ce qui part ou revient lors de ce passage.</div></div> }
					@if (legacy.length) {
						<div class="row group"><div class="c">{{ locked ? 'Ancienne ligne de reprise de ce BL' : 'Ancienne ligne de reprise : retirée de ce BL à l\'enregistrement, la reprise se fait par −1 sur la ligne louée' }} ({{ legacy.length }})</div></div>
						@for (r of legacy; track r.id) {
							<div class="row muted legacy">
								<div class="c"></div>
								<div class="c c-dir"></div>
								<div class="c c-seq">{{ r.seq }}</div>
								<div class="c" [class.faint]="!r.patient">{{ r.patient || '—' }}</div>
								<div class="c c-prod"><span [matTooltip]="r.article ? r.title + ' — ' + r.article : r.title">{{ r.title }}</span><small class="lid" matTooltip="Identifiant de la ligne de commande">id {{ r.id }}</small></div>
								<div class="c c-num">{{ r.qty }}</div>
							</div>
						}
					}

					@if (!locked) {
						<div class="row group"><div class="c">{{ patient !== null ? 'À livrer ou à reprendre pour ' + (patient || 'le patient non renseigné') : 'À livrer ou à reprendre chez ce client' }} ({{ otherRows.length }})</div></div>
						@for (r of otherRows; track r.id) {
							<ng-container *ngTemplateOutlet="row; context: { $implicit: r }"></ng-container>
						}
						@if (!otherRows.length) { <div class="row empty"><div class="c">Rien d'autre à livrer ni à reprendre.</div></div> }
						@if (salesLoading) { <div class="row empty"><div class="c">Lecture des commandes de vente du dossier…</div></div> }
						<!-- Audit 31/10 #30 : BL ouvert d'une vente annulée qui désigne ce passage ; le serveur refuserait la signature tant qu'il existe. -->
						@if (deadRows.length) {
							<div class="row group"><div class="c">Commande de vente annulée : BL {{ deadBls.join(', ') }} retiré de ce passage à l'enregistrement ({{ deadRows.length }})</div></div>
							@for (r of deadRows; track r.id) {
								<div class="row muted dead">
									<div class="c"></div>
									<div class="c c-dir"><app-rental-direction [typ]="r.typ" [qty]="r.qty"></app-rental-direction></div>
									<div class="c c-seq">{{ r.seq }}</div>
									<div class="c" [class.faint]="!r.patient">{{ r.patient || '—' }}</div>
									<div class="c c-prod"><span [matTooltip]="r.article ? r.title + ' — ' + r.article : r.title">{{ r.title }}</span><em>vente annulée · cde {{ r.orderId }}</em><small class="lid" matTooltip="Identifiant de la ligne de commande">id {{ r.id }}</small></div>
									<div class="c c-num">{{ r.qty }}</div>
								</div>
							}
						}
						@if (elsewhere.length) {
							<div class="row group"><div class="c">Déjà sur un autre BL ouvert ({{ elsewhere.length }})</div></div>
							@for (r of elsewhere; track r.id) {
								<div class="row muted" [class.reprise]="r.qty < 0">
									<div class="c"></div>
									<div class="c c-dir"><app-rental-direction [typ]="r.typ" [qty]="r.qty"></app-rental-direction></div>
									<div class="c c-seq">{{ r.seq }}</div>
									<div class="c" [class.faint]="!r.patient">{{ r.patient || '—' }}</div>
									<div class="c c-prod"><span [matTooltip]="r.article ? r.title + ' — ' + r.article : r.title">{{ r.title }}</span><em>@for (id of r.elsewhere; track id) { <button type="button" class="party-link" (click)="goToBl(id)" [disabled]="isSaving" matTooltip="Ouvrir l'onglet de ce BL">BL {{ id }} · {{ whenOf(id) }}</button> }</em><small class="lid" matTooltip="Identifiant de la ligne de commande">id {{ r.id }}</small></div>
									<div class="c c-num"></div>
								</div>
							}
						}
					}
				</div>
				<div class="tbl-end"></div>
			</div>

			<ng-template #row let-r>
				<div class="row" [class.reprise]="r.qty < 0" [class.off]="!isChosen(r)">
					<div class="c c-check">
						<input type="checkbox" [checked]="isChosen(r)" [disabled]="locked || isSaving || (!isChosen(r) && closedPose(r))" (change)="toggle(r, $any($event.target))"
							[matTooltip]="!isChosen(r) && closedPose(r) ? closedLine : ''" [attr.aria-label]="(isChosen(r) ? 'Retirer du BL : ' : 'Mettre sur le BL : ') + r.name">
					</div>
					<div class="c c-dir"><app-rental-direction [typ]="r.typ" [qty]="r.qty"></app-rental-direction></div>
					<div class="c c-seq">{{ r.seq }}</div>
					<div class="c" [class.faint]="!r.patient">{{ r.patient || '—' }}</div>
					<div class="c c-prod">
						<span class="prod-name"><a [routerLink]="['/sales/product', r.product]" target="_blank" tabindex="-1" [matTooltip]="r.title">{{ r.title }}</a>@if (r.article) {<small class="article">{{ r.article }}</small>}</span>
						@if (r.packaging) { <em>— {{ r.packaging }}</em> }
						@if (closedPose(r)) { <em>— {{ closedLine }}</em> }
						@if (isSale(r)) { <a class="sale-tag" [routerLink]="['/sales/quotation', r.orderId]" target="_blank" tabindex="-1" [matTooltip]="'Commande de vente ' + r.orderId + ' du dossier : son propre BL dans ce passage'">vente · cde {{ r.orderId }}</a> }
						<small class="lid" matTooltip="Identifiant de la ligne de commande">id {{ r.id }}</small>
					</div>
					<div class="c c-num">{{ r.qty }}</div>
				</div>
			</ng-template>

			<div class="blk plan">
				<form [formGroup]="formGroup">
					<app-planificationdelivery #plan [locked]="locked"
						[loadOrderEventsSubject$]="loadOrderEventsSubject.asObservable()"
						(changed)="onPlanificationChanged()"></app-planificationdelivery>
				</form>
			</div>

			<div class="acts">
				@if (active?.id && !locked) {
					<button type="button" class="btn quiet" (click)="onDelete()" [disabled]="isSaving || salesLoading"><mat-icon>delete</mat-icon>Supprimer le BL</button>
				}
				<span class="grow"></span>
				@if (active?.id) {
					<input #fileInput type="file" hidden (change)="plan.onFileSelected($event)">
					<button type="button" class="btn" (click)="fileInput.click()" aria-label="Ajoutez un fichier"><mat-icon>attach_file</mat-icon>Ajoutez un fichier</button>
				}
			</div>
		</section>

		<aside class="col-side">
			<div class="map" [style.height.px]="382">
				@if (geo.lat !== null && geo.lng !== null) {
					<app-mini-map [lat]="geo.lat" [lon]="geo.lng" [height]="382" [label]="addressLabel" (coordsChange)="onMapCoords($event)"></app-mini-map>
				} @else if (geo.status === 'introuvable') {
					<div class="geo-miss"><mat-icon>wrong_location</mat-icon><span>Adresse non géolocalisable — complétez l'adresse du client (N° et rue, code postal, ville).</span></div>
				}
			</div>
			@if (geo.dirty) {
				<div class="geo-hint" matTooltip="Coordonnées GPS calculées automatiquement — elles seront enregistrées sur l'adresse du client à l'enregistrement du BL.">
					<mat-icon>my_location</mat-icon><span>Coordonnées GPS calculées — enregistrées à la sauvegarde</span></div>
			}
			@if (geo.doubt) {
				<div class="geo-doubt" matTooltip="Position approximative : elle n'est pas enregistrée sur la fiche client. Déplacez le pin sur la carte pour la corriger et l'enregistrer.">
					<mat-icon>help_outline</mat-icon><span>Position approchée — <b>{{ geo.doubt.label }}</b> — non enregistrée</span></div>
			}
			@if (plan.attachs_images.length) {
				<app-image-carousel class="docs" [attachs]="plan.attachs_images"></app-image-carousel>
			} @else {
				<div class="docs-empty"><mat-icon>attach_file</mat-icon><span>Aucune pièce jointe</span></div>
			}
		</aside>
	</div>
</div>
}
